import React from 'react';
import { Typography } from 'antd';
import { Date, Money } from 'common';

const { Text } = Typography;

const AttributeValuePair: React.FC<{
  attribute: string;
  value: string | number | Date | boolean;
  valueType?: 'date' | 'time' | 'dateTime' | 'money' | 'boolean';
}> = (props: {
  attribute: string;
  value: string | number | Date | boolean;
  valueType?: string;
}) => {
  const attribute = <Text strong>{`${props.attribute}:`}</Text>;

  if (props.value === 'undefined' || props.value === null) {
    return <>{attribute}</>;
  }

  let result = (
    <>
      {attribute} {props.value}
    </>
  );

  switch (props.valueType) {
    case 'date':
      result = (
        <>
          {attribute} <Date>{props.value}</Date>
        </>
      );
      break;
    case 'time':
      result = (
        <>
          {attribute} <Date type="time">{props.value}</Date>
        </>
      );
      break;
    case 'dateTime':
      result = (
        <>
          {attribute} <Date type="dateTime">{props.value}</Date>
        </>
      );
      break;
    case 'money':
      result = (
        <>
          {attribute} <Money>{props.value}</Money>
        </>
      );
      break;
    case 'boolean':
      result = (
        <>
          {attribute} {props.value ? 'YES' : 'NO'}
        </>
      );
      break;
    default:
      break;
  }

  return result;
};

export default AttributeValuePair;
